// extracted by mini-css-extract-plugin
export default {"list-editable":"list-editable---QZaj2","button-unlink":"button-unlink---u1IVA"};